<form (ngSubmit)="search()" style="width: 100%">
  <div class="grid filterPanel form-group">
    <div class="col-12 md:col-4 lg:col-2">
      <span class="md-inputfield filterItem">
        <input name="name" type="text" pInputText [(ngModel)]="filterVal.filters.name.value" />
        <label>Name</label>
      </span>
    </div>

    <div class="col-12 md:col-4 lg:col-2">
      <span class="md-inputfield filterItem">
        <input
          name="addressLine1"
          type="text"
          pInputText
          [(ngModel)]="filterVal.filters.addressLine1.value"
        />
        <label>Address</label>
      </span>
    </div>

    <div class="col-12 md:col-4 lg:col-2">
      <span class="md-inputfield filterItem">
        <input name="town" type="text" pInputText [(ngModel)]="filterVal.filters.town.value" />
        <label>Town</label>
      </span>
    </div>

    <div class="col-12 md:col-4 lg:col-2">
      <span class="md-inputfield filterItem">
        <input
          name="postcode"
          type="text"
          pInputText
          [(ngModel)]="filterVal.filters.postcode.value"
        />
        <label>Postcode</label>
      </span>
    </div>

    <div class="col-12 md:col-4 lg:col-2">
      <p-dropdown
        name="organisationTypeName"
        [options]="organisationtypes"
        [(ngModel)]="filterVal.filters.organisationTypeName.value"
        styleClass="filterItem"
        [style]="{ width: '100%' }"
      ></p-dropdown>
    </div>

    <div class="col-12 md:col-4 lg:col-2">
      <button pButton type="submit" label="Search"></button>
      <button pButton type="button" label="Clear" (click)="clearFilter(dt)"></button>
    </div>
  </div>
</form>

<p-table
  #dt
  selectionMode="single"
  [(selection)]="selectedItem"
  [value]="page.items"
  [lazy]="true"
  [rows]="filterVal.rows"
  [responsive]="true"
  [first]="filterVal.first"
  [paginator]="true"
  rowHover="true"
  resizableColumns="true"
  [rowsPerPageOptions]="[5, 20, 50]"
  [pageLinks]="8"
  [totalRecords]="page.total"
  [styleClass]="'data-table-compact'"
  (onLazyLoad)="onGridLazyLoad($event)"
  [sortField]="filterVal.sortField"
  [sortOrder]="filterVal.sortOrder"
  [hidden]="!isLoaded"
  (onRowSelect)="onOrganisationSelected($event)"
>
  <ng-template pTemplate="header">
    <tr>
      <th pSortableColumn="name">Name</th>
      <th pSortableColumn="addressLine1">Address</th>
      <th pSortableColumn="town">Town</th>
      <th pSortableColumn="postcode">Postcode</th>
      <th pSortableColumn="organisationTypeName">Organisation Type</th>
      <th pSortableColumn="dateCreated">Created</th>
      <th pSortableColumn="inactive">Inactive</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-item>
    <tr [pSelectableRow]="item" class="no-wrap-cells">
      <td>{{ item.name }}</td>
      <td>{{ item.addressLine1 }}</td>
      <td>{{ item.town }}</td>
      <td>{{ item.postcode }}</td>
      <td>{{ item.organisationTypeName }}</td>
      <td>{{ item.dateCreated | date : 'dd/MM/yyyy' }}</td>
      <td>{{ item.inactive | date : 'dd/MM/yyyy' }}</td>
    </tr>
  </ng-template>
</p-table>

<!-- DATATABLE -- DEPRECATED
<p-dataTabl #dt selectionMode="single" [(selection)]="selectedItem" [value]="page.items" [lazy]="true" [rows]="filterVal.rows" [responsive]="true" [first]="filterVal.first"
             [paginator]="true" rowHover="true" resizableColumns="true" [rowsPerPageOptions]="[5,20,50]" [pageLinks]="8" [totalRecords]="page.total"
             [styleClass]="'data-table-compact'"
             (onLazyLoad)="onGridLazyLoad($event)" [sortField]="filterVal.sortField" [sortOrder]="filterVal.sortOrder"
             [hidden]="!isLoaded" (onRowClick)="onOrganisationSelected($event)">
  <p-column field="name" header="Name" [sortable]="true" [editable]="false"></p-column>
  <p-column field="addressLine1" header="Address" [sortable]="true" [editable]="false"></p-column>
  <p-column field="town" header="Town" [sortable]="true" [editable]="false"></p-column>
  <p-column field="postcode" header="Postcode" [sortable]="true" [editable]="false"></p-column>
  <p-column field="organisationTypeName" header="Organisation Type"></p-column>
  <p-column field="dateCreated" header="Created" [sortable]="true">
    <ng-template let-row="rowData" pTemplate="body">
      {{row.dateCreated | date:'dd/MM/yyyy'}}
    </ng-template>
  </p-column>
  <p-column field="inactive" header="Inactive">
    <ng-template let-row="rowData" pTemplate="body">
      {{row.inactive | date:'dd/MM/yyyy'}}
    </ng-template>
  </p-column>
</p-dataTable>

-->
